// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'objektiv', 'objektiv Fallback', Objektiv, sans-serif"},"className":"__className_51c67a","variable":"__variable_51c67a"};